let _ = require("underscore");
let Backbone = require("backbone");

let main = function (_, Backbone) {
    return Backbone.Model.extend({
        isValid: function () {
            var self = this,
                now = new Date().getTime(),
                startDateTime = self.get("startDateTime") || 0,
                endDateTime = self.get("endDateTime") || (now + 1);
            return (now > startDateTime) && (now < endDateTime) && !self.get("singe")

        },
        calculateDiscountedPrice: function (price) {
            var self = this, type = self.get("type"), off = self.get("off");
            switch (type) {
                case "Amount":
                    price = price - off;
                    price = Math.max(price, 0);
                    break;
                case "Percentage":
                    price = price * (100 - off) / 100;
                    break;
                default:
                    console.log("Discount type: " + type + " is not supported");
                    break;
            }
            price = parseFloat(price.toFixed(2));
            return price;
        },
        canApplyTo: function (menuItem) {
            var self = this, usages = self.get("uses") || [], index, usage;
            if (!usages || usages.length == 0) {
                return true;
            }

            var allInclude = _.every(usages, function (usage) {
                return !usage.exclusion
            });
            var allExclude = _.every(usages, function (usage) {
                return usage.exclusion
            });
            var categoryApply = null;

            for (index in usages) {
                usage = usages[index];
                if (usage.item && (usage.item.id == menuItem.id)) {
                    return !usage.exclusion;
                }
                if (usage.category && (usage.category.id == menuItem.categoryId)) {
                    categoryApply = !usage.exclusion;
                }
            }

            if (categoryApply === null) {
                return allExclude
            }

            if(allInclude){
                return true
            }

            return !!categoryApply
        }
    });
};

let exportedValue = main(_, Backbone);
module.exports = exportedValue;



// WEBPACK FOOTER //
// ./src/model/DiscountModel.js